
// export default () => ({
    
// })

export default () => ({
    campus: null,
    campusTeacher: null,
})